const getJSONParse = (data: string | null): any | false => {
	try {
		if (!data) throw Error('Empty data');

		const parsedData = JSON.parse(data);
		return parsedData;
	} catch {
		return undefined;
	}
};

const mappedKeys: Record<ManageStorageKeys, string> = {
	SupervisorChange: '@Hympar:SupervisorChange',
	ConsultantModalCount: '@Hympar:ConsultantModal',
	ConsultantModalShown: '@Hympar:ConsultantModalShown'
};

const manageStorage = (method: 'localStorage' | 'sessionStorage' = 'localStorage') => {
	const storage = window[method];

	return {
		get<T>(key: keyof typeof mappedKeys): T {
			return getJSONParse(storage.getItem(mappedKeys[key]));
		},

		set<T>(key: keyof typeof mappedKeys, value: T | ((prevState: T) => T)) {
			if (typeof value === 'function') {
				const prevState = manageStorage(method).get(key);

				const newValue = (value as Function)(prevState);

				storage.setItem(mappedKeys[key], JSON.stringify(newValue));
				return;
			}

			storage.setItem(mappedKeys[key], JSON.stringify(value));
		},

		remove(key: keyof typeof mappedKeys) {
			storage.removeItem(mappedKeys[key]);
		},
	};
};

window.manageStorage = manageStorage;
